<template lang="pug">
  span(
    :style="{ 'background-image': 'url('+src+')', 'width': width, 'height': height}"
    class="curriculum-thumbnail"
  )
</template>

<style lang="scss" scoped>
.curriculum-thumbnail {
  background-size: cover;
  border-radius: 4px;
  display: inline-block;
  background-color: rgba(25, 38, 50, 0.5);
  background-position: 50%;
  background-repeat: no-repeat;
}
</style>

<script>
const userTypes = {
  coach: { width: '60px', height: '60px' },
  student: { width: '100px', height: '100px' },
}

export default {
  props: {
    src: { type: String, default: '' },
    userType: {
      default: 'coach',
      validator: function (value) {
        return Object.keys(userTypes).indexOf(value) !== -1
      },
    },
  },
  computed: {
    width: function () {
      return userTypes[this.userType].width
    },
    height: function () {
      return userTypes[this.userType].height
    },
  },
}
</script>
